module.exports = __webpack_public_path__ + "static/media/LexusLogo.b8aee2e3.png";